import { Box, Modal, Slide, Typography } from "@mui/material";
import { ReactComponent as GatiError } from "../../../../assets/images/GatiError.svg";
import { ReactComponent as OrderEdit } from "../../../../assets/icons/order_icon/orderedit_icon.svg";
import { ReactComponent as Download } from "../../../../assets/icons/order_icon/download.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/icons/order_icon/whitecross_icon.svg";

const GatiErrorModal = ({ openModal, handleClose }) => {
  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
        },
      }}
    >
      <Slide direction="up" in={openModal}>
        <Box
          sx={{
            width: "16vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: ".5vw",
            position: "relative",
            outline: "none",
          }}
        >
          <CrossIcon
            onClick={handleClose}
            style={{
              cursor: "pointer",
              position: "absolute",
              top: -40,
              right: -40,
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "1vw",
              height: "16vw",
              width: "100%",
              background: "#0D0D0D",
              borderRadius: "1vw",
            }}
          >
            {/* <Typography fontFamily={"Poppins"} fontSize={"1vw"} color="white">
              #3486538
            </Typography> */}
            <GatiError />
            <Typography fontFamily={"Poppins"} fontSize={".9vw"} color="white">
              {typeof openModal === "string" ? openModal : "Sorry, Gati’s Server is Down!"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* <Box
              onClick={handleClose}
              style={{ display: "flex", gap: ".25vw", cursor: "pointer" }}
            >
              <OrderEdit />
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: ".7vw",
                  fontWeight: 500,
                  color: "#50C878",
                  textDecoration: "underline",
                }}
              >
                Edit Order
              </Typography>
            </Box>
            <Box
              onClick={handleClose}
              style={{
                display: "flex",
                gap: ".25vw",
                cursor: "pointer",
                alignItems: "center",
              }}
            >
              <Download />
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: ".7vw",
                  fontWeight: 500,
                  color: "#5078C8",
                  textDecoration: "underline",
                }}
              >
                Excel
              </Typography>
            </Box> */}
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

export default GatiErrorModal;
